import React, { Component } from "react"
import { Button, FormGroup, Input, Label, Modal, ModalBody, Card, CardBody, Row, Col } from "reactstrap"
import { NotificationContainer, NotificationManager } from "react-notifications"
import "react-notifications/lib/notifications.css"
import CreditsTable from "../Components/CreditsTable"
import StripeCheckout from "../Components/StripeCheckout"

import QRCodeImage from "../assets/images/qr-code1.png"
import InfoImage from "../assets/images/info.png"
const apiUrl = "https://stripe.idexo.io"

const buyOptions = ["Compute Credits", "Telegram NFT Minter", "Subscriptions"]

const paymentMethods = [
    {
        name: "Credit Card",
        icon: "credit-card"
    },
    {
        name: "Crypto",
        icon: "credit-card"
    }
]
const credit = process.env.REACT_APP_CREDIT_PRICE || 0.15
const products = [
    {
        name: "Bronze",
        count: 50,
        price: 50
    },
    {
        name: "Silver",
        count: 500,
        price: 475
    },
    {
        name: "Gold",
        count: 5000,
        price: 4500
    }
]

const coins = [
    {
        name: "Ethereum",
        symbol: "ETH"
    },
    {
        name: "Binance USD",
        symbol: "BUSD"
    },
    {
        name: "Tether USD",
        symbol: "USDT"
    }
]

class Credits extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedBuyOption: buyOptions[0],
            currentStep: 0,
            selectedPaymentMethod: "Credit Card",
            boughtProduct: null,
            openStripeModal: false,
            selectedCoin: coins[0],
            networkAddress: "r9vZHTjfqgYVbMR3DQmmM5p73LxWSrPL5F",
            networkDestinationTag: "127916",
            openConfirmNetworkAddressModal: false,
            isConfirmedNetworkAddress: false,
            isCompletedOfBuyingCredits: false
        }
    }

    selectPaymentMethod = (paymentMethod) => {
        this.setState({ selectedPaymentMethod: paymentMethod })
    }

    handleSelectBuyOption = (buyOption) => {
        this.setState({ selectedBuyOption: buyOption })
    }

    setOpenStripeModal = (status) => {
        this.setState({
            openStripeModal: status
        })
    }

    setOpenConfirmNetworkAddressModal = (status) => {
        this.setState({
            openConfirmNetworkAddressModal: status
        })
    }

    setCompletedOfBuyingCredits = (status) => {
        this.setState({
            isCompletedOfBuyingCredits: status
        })
    }

    handleProduct = (product) => {
        this.setState({ boughtProduct: product, openStripeModal: this.state.selectedPaymentMethod !== "Crypto" })
    }

    handleClickNextBtnInFirstStep = () => {
        if (this.state.selectedBuyOption !== buyOptions[0]) return
        this.setState({ currentStep: this.state.currentStep + 1 })
    }

    chargePaymentWithStripe = (product, paymentMethod, callback) => {
        try {
            console.log(product, paymentMethod)
            fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    token: localStorage.jwtToken
                },
                body: JSON.stringify({
                    id: paymentMethod.id,
                    amount: product.price.toString(),
                    credits: product.count.toString()
                }),
                json: true
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.error) {
                        alert(data.error + " : " + data.data.raw.message)
                    } else {
                        this.setOpenStripeModal(!this.state.openStripeModal)
                        this.setCompletedOfBuyingCredits(true)
                        NotificationManager.info("Payment is succeeded")
                    }
                    callback()
                })
                .catch((error) => {
                    console.log(error)
                    callback()
                })
        } catch (e) {
            console.log(e)
            callback()
        }
    }

    renderProgressBar = () => {
        let currentState = ((this.state.currentStep - 1) / 2) * 100
        if (this.state.selectedPaymentMethod === "Crypto") {
            currentState = ((this.state.currentStep - 1) / 4) * 100
        }
        return { backgroundImage: `linear-gradient(to right, #eaf2fa ${currentState}%, #eaf2fa50 ${currentState}%)` }
    }

    showSelectProductPage = () => {
        return (
            (this.state.selectedPaymentMethod === "Credit Card" && this.state.currentStep === 2) ||
            (this.state.selectedPaymentMethod === "Crypto" && this.state.currentStep === 3)
        )
    }

    handleSelectCoin = (coin) => {
        this.setState({
            selectedCoin: coin
        })
    }

    isEnableNextStepButton = () => {
        let value = true
        if (this.state.selectedPaymentMethod === "Credit Card") {
            if (this.state.currentStep === 2) value = !!this.state.isCompletedOfBuyingCredits
        } else {
            if (this.state.currentStep === 3) value = !!this.state.boughtProduct
        }

        return value
    }

    copyToClipboard = (text) => {
        const copyData = (e) => {
            e.preventDefault()
            e.clipboardData.setData("text/plain", text)
            document.removeEventListener("copy", copyData)
        }
        document.addEventListener("copy", copyData)
        document.execCommand("copy")
    }

    onClickNextStepButton = () => {
        if (this.state.selectedPaymentMethod === "Crypto" && this.state.currentStep === 4 && !this.state.isConfirmedNetworkAddress) {
            this.setOpenConfirmNetworkAddressModal(true)
            return
        }
        this.setState({ currentStep: this.state.currentStep + 1 })
    }

    onClickPreviousStepButton = () => {
        if (this.state.selectedPaymentMethod === "Crypto" && this.state.currentStep === 5) {
            this.setState({ isConfirmedNetworkAddress: false })
        }

        this.setState({ currentStep: this.state.currentStep - 1 })
    }

    onClickContinueButtonInConfirmModal = () => {
        this.setState({
            currentStep: this.state.currentStep + 1,
            openConfirmNetworkAddressModal: false
        })
    }

    isLastStep = () => {
        return (
            (this.state.selectedPaymentMethod === "Credit Card" && this.state.currentStep === 3) ||
            (this.state.selectedPaymentMethod === "Crypto" && this.state.currentStep === 5)
        )
    }

    render() {
        return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <div className="credits-header">
                                        <h2 className="title">
                                            {this.state.currentStep === 0 ? "Buy Options" : `Buy Idexo ${this.state.selectedBuyOption}`}
                                        </h2>
                                        {this.state.currentStep > 0 && (
                                            <div className="steps-bar">
                                                <div className="labels d-flex justify-content-between">
                                                    {(this.state.selectedPaymentMethod === "Credit Card" ? [1, 2, 3] : [1, 2, 3, 4, 5]).map(
                                                        (stepNo) => (
                                                            <span
                                                                key={stepNo}
                                                                className={
                                                                    stepNo === this.state.currentStep
                                                                        ? "active"
                                                                        : stepNo < this.state.currentStep
                                                                          ? "passed"
                                                                          : ""
                                                                }
                                                            >
                                                                Step {stepNo}
                                                            </span>
                                                        )
                                                    )}
                                                </div>
                                                <div className="steps d-flex justify-content-between">
                                                    {(this.state.selectedPaymentMethod === "Credit Card" ? [1, 2, 3] : [1, 2, 3, 4, 5]).map(
                                                        (stepNo) => (
                                                            <div
                                                                key={stepNo}
                                                                className={`step-dot ${
                                                                    stepNo === this.state.currentStep
                                                                        ? "active"
                                                                        : stepNo < this.state.currentStep
                                                                          ? "passed"
                                                                          : ""
                                                                }`}
                                                            />
                                                        )
                                                    )}
                                                    <div className="line" style={this.renderProgressBar()} />
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {this.state.currentStep === 0 ? (
                                        <div className="credits-body">
                                            <p className="title">Please select Buy Option</p>
                                            <div className="payment-methods">
                                                {buyOptions.map((buyOption) => (
                                                    <Button
                                                        key={buyOption}
                                                        color="primary"
                                                        outline
                                                        className={`waves-effect waves-light payment-method-btn ${
                                                            this.state.selectedBuyOption === buyOption ? "active" : ""
                                                        }`}
                                                        onClick={() => this.handleSelectBuyOption(buyOption)}
                                                    >
                                                        {buyOption}
                                                    </Button>
                                                ))}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="credits-body">
                                            {this.state.currentStep === 1 && (
                                                <>
                                                    <p className="title">Payment Methods</p>
                                                    <div className="payment-methods">
                                                        {paymentMethods.map((paymentMethod) => (
                                                            <Button
                                                                key={paymentMethod.name}
                                                                color="primary"
                                                                outline
                                                                className={`waves-effect waves-light payment-method-btn ${
                                                                    this.state.selectedPaymentMethod === paymentMethod.name ? "active" : ""
                                                                }`}
                                                                onClick={() => this.selectPaymentMethod(paymentMethod.name)}
                                                            >
                                                                {paymentMethod.name}
                                                            </Button>
                                                        ))}
                                                    </div>
                                                </>
                                            )}
                                            {this.state.currentStep === 2 && this.state.selectedPaymentMethod === "Crypto" && (
                                                <>
                                                    <p className="title">Payment Methods</p>
                                                    <div className="payment-methods">
                                                        {coins.map((coin) => (
                                                            <Button
                                                                key={coin.name}
                                                                color="primary"
                                                                outline
                                                                className={`waves-effect waves-light payment-method-btn ${
                                                                    this.state.selectedCoin === coin ? "active" : ""
                                                                }`}
                                                                onClick={() => this.handleSelectCoin(coin)}
                                                            >
                                                                {coin.name} {coin.symbol}
                                                            </Button>
                                                        ))}
                                                    </div>
                                                </>
                                            )}
                                            {this.showSelectProductPage() && (
                                                <>
                                                    <p className="title">I would to like buy</p>
                                                    <div className="d-flex justify-content-center">
                                                        <div className="price">
                                                            <div className="credits">
                                                                {this.state.boughtProduct?.count || 0} <span>CREDITS</span>
                                                            </div>
                                                            <p className="text-muted text-center">${this.state.boughtProduct?.price || 0}</p>
                                                        </div>
                                                    </div>
                                                    <div className="product-list">
                                                        {products.map((product) => (
                                                            <div key={product.name} className="product-container">
                                                                <Button
                                                                    color="primary"
                                                                    outline
                                                                    className={`waves-effect waves-light ${
                                                                        this.state.boughtProduct?.name === product.name ? "active" : ""
                                                                    }`}
                                                                    onClick={() => this.handleProduct(product)}
                                                                >
                                                                    {product.count} CREDITS
                                                                </Button>
                                                                <span className="product-bouns">${product.price}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {/*<p className="text-center text-muted mt-4 mb-0">Retail price is ${credit}</p>*/}
                                                </>
                                            )}
                                            {this.state.selectedPaymentMethod === "Crypto" && this.state.currentStep === 4 && (
                                                <div className="network">
                                                    <p className="title">Fund your {this.state.selectedCoin.name} checking address:</p>
                                                    <div className="qr-code-img">
                                                        <img src={QRCodeImage} alt={"qr-code"} />
                                                    </div>
                                                    <h5>Network Type</h5>
                                                    <Button color="primary" outline className={`waves-effect waves-light active`}>
                                                        {this.state.selectedCoin.symbol}
                                                    </Button>

                                                    <h5>My PointPay {this.state.selectedCoin.name} address:</h5>
                                                    <span className="address">{this.state.networkAddress}</span>
                                                    <Button
                                                        className="copy-to-clipboard"
                                                        onClick={() => this.copyToClipboard(this.state.networkAddress)}
                                                    >
                                                        <i className="bx bx-copy"></i>
                                                    </Button>

                                                    <p>
                                                        Send only {this.state.selectedCoin.symbol} to this deposit address.
                                                        <br />
                                                        Sending coins or tokens other than {this.state.selectedCoin.symbol} to this address with
                                                        another network type will result in the loss of your deposit.
                                                    </p>

                                                    <h5>My PointPay {this.state.selectedCoin.name} destination tag:</h5>
                                                    <span className="address">{this.state.networkDestinationTag}</span>
                                                    <Button
                                                        className="copy-to-clipboard"
                                                        onClick={() => this.copyToClipboard(this.state.networkDestinationTag)}
                                                    >
                                                        <i className="bx bx-copy"></i>
                                                    </Button>

                                                    <p>
                                                        Please make sure to provide both tag and address.
                                                        <br />
                                                        If they are not provided or provided incorrectly, the funds will be lost.
                                                    </p>
                                                </div>
                                            )}
                                            {this.isLastStep() && <CreditsTable />}
                                        </div>
                                    )}

                                    <div
                                        className={`credits-footer ${
                                            this.state.currentStep > 0 ? "justify-content-between" : "justify-content-center"
                                        }`}
                                    >
                                        {this.state.currentStep === 0 ? (
                                            <Button
                                                color="primary"
                                                outline
                                                className="waves-effect waves-light step-change-btn next-btn"
                                                onClick={() => this.handleClickNextBtnInFirstStep()}
                                            >
                                                Next
                                                <i className="bx bx-arrow-back" />
                                            </Button>
                                        ) : (
                                            <>
                                                {this.state.currentStep > 0 && (
                                                    <Button
                                                        color="primary"
                                                        outline
                                                        className="waves-effect waves-light step-change-btn previous-btn"
                                                        onClick={() => this.onClickPreviousStepButton()}
                                                    >
                                                        <i className="bx bx-arrow-back" />
                                                        {this.state.currentStep === 1 ? "Back" : "Previous Step"}
                                                    </Button>
                                                )}
                                                {this.isLastStep() ? (
                                                    <Button color="primary" outline className="waves-effect waves-light step-change-btn next-btn">
                                                        Buy CREDITS tokens
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        color="primary"
                                                        outline
                                                        className="waves-effect waves-light step-change-btn next-btn"
                                                        onClick={() => this.onClickNextStepButton()}
                                                        disabled={!this.isEnableNextStepButton()}
                                                    >
                                                        Next step
                                                        <i className="bx bx-arrow-back" />
                                                    </Button>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <NotificationContainer />
                <Modal
                    isOpen={this.state.openStripeModal}
                    fade={false}
                    toggle={() => this.setOpenStripeModal(!this.state.openStripeModal)}
                    className="wallet-info-modal"
                >
                    <ModalBody>
                        <StripeCheckout
                            product={this.state.boughtProduct}
                            chargePrice={this.chargePaymentWithStripe}
                            closeModal={() => this.setOpenStripeModal(false)}
                        />
                    </ModalBody>
                </Modal>
                <Modal
                    isOpen={this.state.openConfirmNetworkAddressModal}
                    fade={false}
                    toggle={() => this.setOpenConfirmNetworkAddressModal(!this.state.openConfirmNetworkAddressModal)}
                    className="confirmModal"
                >
                    <ModalBody>
                        <img src={InfoImage} alt={"img"} />
                        <h3>If you sent the funds to this address</h3>
                        <p>
                            It may take time to have your transaction confirmed in the blockchain. Average confirmation time may vary from a few
                            minutes to 24 hours. If your deposit was not credited to your account, please contact our customer support center.
                        </p>

                        <FormGroup className="mb-2 confirm-checkbox">
                            <Input
                                type="checkbox"
                                name="confirm-checkbox"
                                id="confirm-checkbox"
                                onClick={() => this.setState({ isConfirmedNetworkAddress: !this.state.isConfirmedNetworkAddress })}
                            />
                            <Label htmlFor="confirm-checkbox">I understand the paragraph above</Label>
                        </FormGroup>

                        <Button
                            color="primary"
                            outline
                            className="waves-effect waves-light step-change-btn next-btn"
                            onClick={() => this.onClickContinueButtonInConfirmModal()}
                            disabled={!this.state.isConfirmedNetworkAddress}
                        >
                            Continue
                        </Button>
                    </ModalBody>
                </Modal>
            </React.Fragment>
        )
    }
}

export default Credits
